<!-- 稼働日カレンダー未入力アラートモーダル -->
<script lang="ts" setup>
import { ref, watch } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import RowCheckBox from '../atom/RowCheckBox.vue';
import router from '@/router';
import { getCalendar } from '@/appLogic/checkCalendar';
import { putPreference } from '@/appLogic/preferenceManage';
import { simpleCopy } from '@/utils/deepCopy';
import { getOrganizationId } from '@/utils/token';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { i18n } from '@/i18n';

const t = i18n.t;

const props = withDefaults(
  defineProps<{
    isOpenModal: boolean;
  }>(),
  {}
);

const emits = defineEmits<{
  (e: 'outside-click', status: boolean): void;
}>();

const isShowModal = ref(false);
const isDisplayToday = ref(false);

// 親コンポーネントから渡ってきたopen/closeのフラグを監視する
watch(
  () => props.isOpenModal,
  () => {
    isShowModal.value = props.isOpenModal;
  }
);

const closeModal = () => {
  if (isDisplayToday.value) {
    putShowCalendarInfo(isDisplayToday.value);
  }
  isShowModal.value = false;
  emits('outside-click', false);
};

const sendCalendarPage = async () => {
  if (isDisplayToday.value) {
    putShowCalendarInfo(isDisplayToday.value);
  }
  await router.push('/calendar');
};

/**
 * 「今日は表示しない」チェックボックスの値と、チェック日時の登録を行う
 * @param checkboxStatus
 */
const putShowCalendarInfo = async (checkboxStatus: boolean) => {
  const calendar = simpleCopy(await getCalendar());
  calendar.unRegisterCalendarAlert.updateAt = Math.floor(new Date().getTime() / 1000);
  calendar.updatedAt = Math.floor(new Date().getTime() / 1000);
  calendar.unRegisterCalendarAlert.isDisplay = !checkboxStatus;
  calendar.workDays.sort(DateService.compareYearMonths);
  await putPreference(await getOrganizationId(), 'calendar', calendar).catch((err) => console.log('err', err));
};
</script>
<template>
  <Modal
    class="work-days-alert-modal-container"
    :modal-size="480"
    :aspect-ratio="true"
    :stretch-container="true"
    :scroll-off="true"
    :padding="'16px'"
    :modal-state="props.isOpenModal"
    @outside-click="closeModal()"
  >
    <div class="work-days-alert-modal-content work-days-alert-modal-container__work-days-alert-modal-content">
      <div class="work-days-alert-modal-content__title">
        <div>稼働日カレンダーを登録してください。</div>
        <div>Please register working calender.</div>
      </div>
      <div class="text-container work-days-alert-modal-content__text-container">
        <div class="text-container__text-content">
          稼働日が5日以下の月が存在しています。<br />
          There are months with less than 6 working days.
        </div>
        <div class="text-container__check-box">
          <RowCheckBox :is-checked="isDisplayToday" @change-status="isDisplayToday = $event" />
          本日は表示しない Don't show today
        </div>
      </div>
      <div class="action-confirm-button-container">
        <TextButton
          :color="'primary'"
          :size="'btn-md'"
          class="action-confirm-button-container__action-confirm-button"
          @click="sendCalendarPage()"
        >
          稼働日カレンダーを登録<br />
          Register working calender
        </TextButton>
      </div>
    </div>
  </Modal>
</template>
<style lang="scss" scoped>
.work-days-alert-modal-content {
  margin: 0;
  height: 100%;
  display: grid;
  grid-template-rows: minmax(0, 0.2fr) minmax(0, 0.6fr) minmax(0, 0.2fr);
  grid-gap: 12px;
  padding: 32px 0;
  &__title {
    display: grid;
    gap: 8px;
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin: auto;
  }
}

.text-container {
  display: grid;
  grid-template-rows: minmax(0, 0.6fr) minmax(0, 0.4fr);
  grid-gap: 8px;
  font-size: 16px;
  justify-content: center;
  padding: 16px 0;
  &__text-content {
    font-size: 16px;
    text-align: center;
  }
  &__check-box {
    font-size: 16px;
    text-align: left;
    display: flex;
    gap: 4px;
    align-items: end;
    justify-content: center;
  }
}
.action-confirm-button-container {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  &__action-confirm-button {
    height: 48px;
    padding: 0 8px;
  }
}
</style>
